import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  selectedVideoPaths: [],
  editedVideoName: "video",
  showSlider: false,
  startTime: 0,
  duration: 0,
  text: "",
  videoPathForTrim: "",
  showTrimmer: false,
  editIcons: false,
  selectedTheme: "",
  highlightTitle: "",
  themeImageUrl: "",
  showToolkit: false,
  showToolkitSecond: false,
  toolkitUrl: [],
  themeHighlightTitleColor: "",
  themePopup: false,
  isOverlayText: "",
  showSelectionToolkit: false,
  themeImageUrlSend: "",
  editedVideoPosition: "replace",
  isEditedFlag: false,
  isBackDrop: false,
  isProgressBar: false,
  isFinishedEdit: false,
  isNameDialog: false,
  isVideoEditPopup: false,
  videoEditPopupData: {},
  playlistsData: {},
};

export const VideoHighlightReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.SET_PLAYLIST_DATA: {
      const { media, highlights, playlistId } = payload;
      return {
        ...state,
        playlistsData: {
          ...state.playlistsData,
          [playlistId]: {
            media: media,
            highlights: highlights,
          },
        },
      };
    }

    case ActionTypes.RENAME_VIDEO_FROM_PLAYLIST: {
      const { playlistId, videoId, videoName } = payload;
      const currentPlaylist = state?.playlistsData[playlistId];
      if (!currentPlaylist) return state; // If no playlist found, return current state

      // Map through media and highlights to rename the specified video
      const updatedMedia = currentPlaylist?.media?.map((video) =>
        video?.id === videoId
          ? { ...video, eventMediaCategory: videoName }
          : video
      );
      const updatedHighlights = currentPlaylist?.highlights?.map((video) =>
        video?.id === videoId
          ? { ...video, eventMediaCategory: videoName }
          : video
      );

      return {
        ...state,
        playlistsData: {
          ...state.playlistsData,
          [playlistId]: {
            ...currentPlaylist,
            media: updatedMedia,
            highlights: updatedHighlights,
          },
        },
      };
    }

    case ActionTypes.REMOVE_VIDEO_FROM_PLAYLIST: {
      const { playlistId, videoId } = payload;
      const currentPlaylist = state?.playlistsData[playlistId];
      if (!currentPlaylist) return state; // If no playlist found, return current state
      // Filter out the video from media and highlights
      const updatedMedia = currentPlaylist?.media?.filter(
        (video) => video?.id !== videoId
      );
      const updatedHighlights = currentPlaylist?.highlights?.filter(
        (video) => video?.id !== videoId
      );
      return {
        ...state,
        playlistsData: {
          ...state.playlistsData,
          [playlistId]: {
            ...currentPlaylist,
            media: updatedMedia,
            highlights: updatedHighlights,
          },
        },
      };
    }

    case ActionTypes.UPDATE_PLAYLIST_MEDIA: {
      const { playlistId, newMedia } = payload;
      // Ensure the playlist exists in the state
      const currentPlaylist = state.playlistsData[playlistId] || {
        media: [],
        highlights: [],
      };
      // Filter out old media/highlight with the same id if it exists
      const updatedMedia = currentPlaylist.media.filter(
        (item) => item.id !== newMedia.id
      );
      const updatedHighlights = currentPlaylist.highlights.filter(
        (item) => item.id !== newMedia.id
      );
      // Conditionally add the new media to media or highlights
      if (newMedia.isEdited) {
        updatedHighlights.push(newMedia); // Add to highlights if edited
      } else {
        updatedMedia.push(newMedia); // Add to media if not edited
      }
      return {
        ...state,
        playlistsData: {
          ...state.playlistsData,
          [playlistId]: {
            media: updatedMedia,
            highlights: updatedHighlights,
          },
        },
      };
    }

    case ActionTypes.SET_VIDEO_EDIT_DATA:
      return {
        ...state,
        selectedVideoPaths: state.selectedVideoPaths.map((selectedVideo) => {
          if (selectedVideo.path === payload.path) {
            return {
              ...selectedVideo,
              startTime: payload.startTime,
              duration: payload.duration,
              text: payload.text,
            };
          } else {
            return selectedVideo;
          }
        }),
      };
    case ActionTypes.OPEN_NAME_DIALOG:
      return {
        ...state,
        isNameDialog: payload,
      };

    case ActionTypes.REPLACE_EDITED_INTERCUT_VIDEO_LOADING:
      return {
        ...state,
        videoEditPopupData: {
          ...state.videoEditPopupData,
          loading: payload,
        },
      };

    case ActionTypes.OPEN_VIDEO_EDIT_POPUP:
      return {
        ...state,
        isVideoEditPopup: payload,
      };
    case ActionTypes.VIDEO_EDIT_POPUP_DATA:
      return {
        ...state,
        videoEditPopupData: payload,
      };
    case ActionTypes.SET_BACKDROP:
      return {
        ...state,
        isBackDrop: payload,
      };
    case ActionTypes.SET_FINISHED_EDIT:
      return {
        ...state,
        isFinishedEdit: payload,
      };
    case ActionTypes.SET_EDITED_VIDEO_POSITION:
      return {
        ...state,
        editedVideoPosition: payload,
      };
    case ActionTypes.SET_SELECTED_VIDEO_PATH:
      return {
        ...state,
        selectedVideoPaths: payload,
      };
    case ActionTypes.SET_EDITED_VIDEO_NAME:
      return {
        ...state,
        editedVideoName: payload,
      };
    case ActionTypes.SET_PROGRESS_BAR:
      return {
        ...state,
        isProgressBar: payload,
      };
    case ActionTypes.SET_VIDEO_PATH_FOR_TRIM:
      return {
        ...state,
        videoPathForTrim: payload,
      };
    case ActionTypes.SET_TEXT:
      return {
        ...state,
        text: payload,
      };
    case ActionTypes.SET_START_TIME:
      return {
        ...state,
        startTime: payload,
      };
    case ActionTypes.SET_DURATION:
      return {
        ...state,
        duration: payload,
      };
    case ActionTypes.SET_SHOW_SLIDER:
      return {
        ...state,
        showSlider: payload,
      };
    case ActionTypes.SET_SHOW_TRIMMER:
      return {
        ...state,
        showTrimmer: payload,
      };
    case ActionTypes.SET_EDIT_ICONS:
      return {
        ...state,
        editIcons: payload,
      };
    case ActionTypes.SET_SELECTED_THEME:
      return {
        ...state,
        selectedTheme: payload,
      };
    case ActionTypes.SET_HIGHLIGHT_TITLE:
      return {
        ...state,
        highlightTitle: payload,
      };
    case ActionTypes.SET_THEME_IMAGE_URL:
      return {
        ...state,
        themeImageUrl: payload,
      };
    case ActionTypes.SET_SHOW_TOOLKIT:
      return {
        ...state,
        showToolkit: payload,
      };
    case ActionTypes.SET_SHOW_TOOLKIT_SECOND:
      return {
        ...state,
        showToolkitSecond: payload,
      };
    case ActionTypes.SET_TOOLKIT_URL:
      return {
        ...state,
        toolkitUrl: payload,
      };
    case ActionTypes.SET_THEME_HIGHLIGHT_TITLE_COLOR:
      return {
        ...state,
        themeHighlightTitleColor: payload,
      };
    case ActionTypes.SET_THEME_POPUP:
      return {
        ...state,
        themePopup: payload,
      };
    case ActionTypes.SET_IS_OVERLAY_TEXT:
      return {
        ...state,
        isOverlayText: payload,
      };
    case ActionTypes.SET_SHOW_SELECTION_TOOLKIT:
      return {
        ...state,
        showSelectionToolkit: payload,
      };
    case ActionTypes.SET_THEME_IMAGE_URL_SEND:
      return {
        ...state,
        themeImageUrlSend: payload,
      };

    case ActionTypes.HANDLE_EDIT_ICON_CLICK:
      return {
        ...state,
        showSlider: payload.showSlider,
        startTime: payload.startTime,
        duration: payload.duration,
        text: payload.text,
        videoPathForTrim: payload.videoPathForTrim,
        showTrimmer: payload.showTrimmer,
        editIcons: payload.editIcons,
        showToolkit: payload.showToolkit,
        isOverlayText: payload.isOverlayText,
      };
    case ActionTypes.SET_DATA_AFTER_VIDEO_EDIT:
      return {
        ...state,
        text: payload.text,
        startTime: payload.startTime,
        duration: payload.duration,
        editedVideoName: payload.editedVideoName,
        themeImageUrl: payload.themeImageUrl,
        showSlider: payload.showSlider,
        editIcons: payload.editIcons,
        showSelectionToolkit: payload.showSelectionToolkit,
      };
    case ActionTypes.HANDLE_DELETED_VIDEO:
      return {
        ...state,
        selectedVideoPaths: payload.selectedVideoPaths,
        showSlider: payload.showSlider,
        editIcons: payload.editIcons,
      };
    case ActionTypes.HANDLE_VIDEO_SELECTION:
      return {
        ...state,
        showSlider: payload.showSlider,
        showTrimmer: payload.showTrimmer,
        editIcons: payload.editIcons,
        showToolkit: payload.showToolkit,
        isOverlayText: payload.isOverlayText,
        showSelectionToolkit: payload.showSelectionToolkit,
      };
    default:
      return state;
  }
};
